export default "__VITE_ASSET__aea206bd__"